import { createApp } from 'vue/dist/vue.esm-bundler';
import routes from '@js/app/router/router';
import {
    createRouter,
    createWebHashHistory,
    createWebHistory,
} from 'vue-router';
import { createPinia } from 'pinia';
import App from '@js/app/App.vue';
import i18n from '@js/app/plugins/i18n';
// import * as Sentry from '@sentry/vue';

import { VueReCaptcha } from 'vue-recaptcha-v3';

document.addEventListener('DOMContentLoaded', () => {
    const appId = '#app-lk-student';
    const appBlock = document.querySelector(appId);

    if (typeof appBlock !== 'undefined' && appBlock != null) {
        const isForceDevHost = ['develop.intercollege.orog.ru'].includes(window.location.hostname);
        
        const router = createRouter({
            history: IS_DEVELOPMENT || isForceDevHost
                ? createWebHashHistory()
                : createWebHistory(),
            routes,
            scrollBehavior(to, from, savedPosition) {
                return { top: 0, behavior: 'smooth' };
            },
        });

        const app = createApp(App);
        app.use(router);

        const pinia = createPinia();
        pinia.use(({ store }) => {
            store.router = router;
            store.api.assets = ENV.APP_URL_ASSET;
            store.api.url = ENV.APP_API_URL;
            store.api.url_pay = ENV.APP_API_URL_PAY;
        });
        app.use(pinia);

        app.use(i18n);

        app.use(VueReCaptcha, {
            siteKey: ENV.APP_RECAPTCHA_SITE_KEY,
            // loaderOptions: {
            //     useRecaptchaNet: true,
            // },
        });

        // app.config.errorHandler = (err: any, vm: any, info: any) => {
        //     console.log('err', err);
        //     console.log('vm', vm);
        //     console.log('info', info);
        // };

        // Sentry.init({
        //     app,
        //     dsn: ENV.APP_SENTRY_DSN,
        // });

        app.mount(appId);
    }
});
